import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { getItems, clearItem } from '../../actions/actions'
import { List, InfiniteLoader, AutoSizer } from 'react-virtualized'
import css from './styles.scss'

export class Items extends Component {
  constructor ({ items: { items }, dispatch }) {
    super()
    this.state = {
      refreshing: false,
      loading: true,
      showContact: false
    }
    this.fetched = []
    dispatch(clearItem())
  }

  componentDidMount () {
    this.props.dispatch(getItems()).then(() => {
      this.setState({
        loading: false,
        refreshing: false
      })
    })
  }

  formatInstanceCount = (count) => {
    if (count > 999) {
      return String((count / 1000).toFixed(1)) + 'K'
    } else {
      return String(count)
    }
  }

  loadMoreRows = () => {
    const { items: { items, hasNext } } = this.props
    const numItems = items.length
    if (!hasNext || !numItems) {
      return
    }
    const maxCreatedAt = items[numItems - 1].createdAt
    if (this.fetched.indexOf(maxCreatedAt) === -1) {
      this.fetched.push(maxCreatedAt)
      this.props.dispatch(getItems(maxCreatedAt))
    }
  };

  // isRowLoaded = ({index}) => this.props.items.hasNext;
  isRowLoaded = ({ index }) => {
    return this.state.loading && this.state.refreshing
    // this.props.items.hasNext;
  }

  handleNewItem = () => {
    this.setState({
      showContact: true
    })
  }

  renderRow = ({ index, key, style }) => {
    const { items: { items } } = this.props
    const item = items[index]
    return (
      <div key={key} style={style} className={css.listing}>
        <span>
          <Link to={`/item/${item.id}`}><span> {item.name}</span></Link>
        </span>
        <span>
          <Link to={`/variations/${item.id}`}>
            {this.formatInstanceCount(item.numInstances)} <small>Variations</small>
          </Link>
        </span>
        <span>
          {item.templateIds ? item.templateIds.length : '0'} <small>Templates</small>
        </span>
      </div>
    )
  };

  render () {
    const { loading, showContact } = this.state
    const { items: { items } } = this.props
    const rowCount = items.length || 0
    let newItemCTA = (
      <div className={css.fakeNew}>
        <button className={css.button} onClick={this.handleNewItem}>New Item</button>
        <p className={css.message} style={{ display: showContact ? 'inline-block' : 'none' }}>
          To create a SmartItem please contact Benjamin Hunter: <a href='mailto:Benjamin.Hunter@caveon.com'>Benjamin.Hunter@caveon.com</a>
        </p>
      </div>
    )
    let content = null
    if (this.props.user.roles && this.props.user.roles.indexOf('partner') > -1) {
      newItemCTA = <Link to='/item' className={css.button}>New Item</Link>
    }
    if (loading) {
      content = <div className={css.loading}>Loading Items...</div>
    } else {
      content = (
        <InfiniteLoader
          isRowLoaded={this.isRowLoaded}
          loadMoreRows={this.loadMoreRows}
          rowCount={rowCount}
        >
          {({ onRowsRendered, registerChild }) => (
            <AutoSizer>
              {({ width, height }) => (
                <List
                  ref={registerChild}
                  onRowsRendered={onRowsRendered}
                  rowRenderer={this.renderRow}
                  height={height}
                  width={width}
                  rowHeight={50}
                  rowCount={rowCount}
                />
              )}
            </AutoSizer>
          )}
        </InfiniteLoader>
      )
    }
    return (
      <div className={css.container}>
        <div className={css.pageTools}>
          {newItemCTA}
        </div>
        <div className={css.itemList}>
          {content}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { items, user } = state
  return {
    items,
    user
  }
}

export default connect(mapStateToProps)(Items)



// WEBPACK FOOTER //
// /app/js/components/Items/index.js